import type { IntegrationName, OrgPlanName } from "@tellescope/tanstack-query";
import { getPlanIntegrationConfigs } from "./constants";
import { IntegrationConfig } from "./types";

export const getPlanIntegrations = ({ plan }: { plan: OrgPlanName }): IntegrationConfig[] =>
  getPlanIntegrationConfigs(plan);

export const getPlanDefaultIntegrations = ({ plan }: { plan: OrgPlanName }): IntegrationName[] =>
  getPlanIntegrations({ plan }).reduce<IntegrationName[]>((acc, curr) => {
    if (curr.required || curr.default) {
      acc.push(curr.name);
    }
    return acc;
  }, []);

export const getPlanRequiredIntegrations = ({ plan }: { plan: OrgPlanName }): IntegrationName[] =>
  getPlanIntegrations({ plan }).reduce<IntegrationName[]>((acc, curr) => {
    if (curr.required) {
      acc.push(curr.name);
    }
    return acc;
  }, []);
